<template>
  <div>
    <div class="card-container">
      <div class="card-title">
        数据筛选
      </div>
      <div class="card-content">
        <a-form ref="searchForm" :form="form">
          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item label="昵称" v-bind="formItemLayout">
                <a-input
                  v-decorator="['userName']"
                  allow-clear
                  placeholder="请输入昵称"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="手机号" v-bind="formItemLayout">
                <a-input
                  v-decorator="['cellPhone']"
                  allow-clear
                  placeholder="请输入手机号搜索"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="审核人" v-bind="formItemLayout">
                <a-input
                  v-decorator="['handleName']"
                  allow-clear
                  placeholder="请输入审核人"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item label="上传时间" v-bind="formItemLayout">
                <a-date-picker
                  v-decorator="['uploadDate']"
                  show-time
                  type="date"
                  placeholder="发布时间"
                  style="width: 100%;"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="审核状态" v-bind="formItemLayout">
                <a-select
                  v-decorator="['state']"
                  allow-clear
                  placeholder="全部"
                  show-search
                >
                  <a-select-option
                    v-for="(item, index) in markList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="12" align="right">
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetForm">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container">
      <div class="card-title">
        <a-row>
          <a-col :span="12">
            审核列表
          </a-col>
        </a-row>
      </div>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="data"
          :row-key="record => Math.random() * 10000"
          :loading="loading"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <template slot="images" slot-scope="images">
            <img
              style="width:100px;height:50px;cursor: pointer;"
              :src="images"
              @click="showPicture(images)"
            >
          </template>
          <template slot="state" slot-scope="text, record">
            <div v-show="record.state == 0">
              待审核
            </div>
            <div v-show="record.state == 1">
              已到账
            </div>
            <div v-show="record.state == 2">
              拒绝
            </div>
          </template>
          <template slot="operate" slot-scope="text, record">
            <a-button type="link" size="small" @click="lookInfo(record.id)">
              查看
            </a-button>
            <a-button
              v-show="record.state == 0" type="link" size="small"
              @click="look(record.id)"
            >
              审核
            </a-button>
            <a-button type="link" size="small" @click="del(record.id)">
              删除
            </a-button>
          </template>
        </a-table>
      </div>
    </div>
    <a-modal
      v-model="deleteVisible"
      ok-text="确定"
      cancel-text="取消"
      class="comModal"
      @ok="deleteModal"
    >
      <div class="dlContent">
        <icon-font type="iconShape" class="dlIcon"></icon-font>
        <span class="dlTitle">提示</span>
        <div class="dlMain">
          是否确定删除此订单？
        </div>
      </div>
    </a-modal>
    <a-modal v-model="picVisible" :footer="null">
      <img :src="picSrc">
    </a-modal>
  </div>
</template>

<script>
import { iconFontComponent } from '@/components/mixins/mixins.js'
export default {
  mixins: [iconFontComponent],
  data () {
    return {
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      markList: [
        {
          id: '0',
          name: '待审核'
        },
        {
          id: '1',
          name: '已到账'
        },
        {
          id: '2',
          name: '拒绝'
        }
      ],
      stateCount: {},
      region: [],
      areas: [],
      form: this.$form.createForm(this),
      uploadTime: [],
      loading: false,
      columns: [
        {
          title: '审核编号',
          dataIndex: 'orderNo',
          width: 100
        },
        {
          title: '分类图片',
          dataIndex: 'images',
          scopedSlots: { customRender: 'images' },
          width: 150
        },
        {
          title: '昵称',
          dataIndex: 'userName',
          width: 80
        },
        {
          title: '手机号',
          dataIndex: 'cellPhone',
          width: 100
        },
        {
          title: '上传时间',
          dataIndex: 'createTime',
          width: 100
        },
        {
          title: '审核时间',
          dataIndex: 'handleTime',
          width: 100
        },
        {
          title: '审核人',
          dataIndex: 'handleName',
          width: 80
        },
        {
          title: '审核状态',
          width: 80,
          scopedSlots: { customRender: 'state' }
        },
        {
          title: '操作',
          width: 100,
          scopedSlots: { customRender: 'operate' }
        }
      ],
      data: [],
      pagination: {
        pageNo: 1,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      state: -1,
      deleteVisible: false,
      delId: '',
      picSrc: '',
      picVisible: false
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    showPicture (url) {
      this.picSrc = url
      this.picVisible = true
    },
    toSearch () {
      this.pagination.pageNo = 1
      this.getTableData()
    },
    resetForm () {
      this.state = -1
      this.form.resetFields()
      this.pagination.pageNo = 1
      this.getTableData()
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNo = pagination.current
      this.getTableData()
    },
    getTableData () {
      var param = this.form.getFieldsValue()
      param.page = this.pagination.pageNo
      param.pageSize = this.pagination.pageSize
      this.loading = true
      this.$httpPost(this.$basePath.rewardEnvironmentalList, param)
        .then(res => {
          console.log(res)
          res.result.list.forEach(dat => {
            dat.images = dat.paths.split(',')[0]
          })
          this.data = res.result.list
          this.pagination.total = res.result.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    lookInfo (id) {
      this.$router.push({
        path: '/scoreReview/info',
        query: {
          id: id,
          status: 'view'
        }
      })
    },
    look (id) {
      this.$router.push({
        path: '/scoreReview/info',
        query: {
          id: id,
          status: 'shenhe'
        }
      })
    },
    del (id) {
      this.deleteVisible = true
      this.delId = id
    },
    deleteModal () {
      this.$httpPost(this.$basePath.delRewardEnvironmental, {
        id: this.delId
      }).then(res => {
        this.$message.success(res.msg)
        this.deleteVisible = false
        this.toSearch()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
>>>.ant-upload-hint
  width 70%
  margin 4px auto 10px auto
>>>.ant-upload-drag-icon
  margin-top 32px
.upload-select
  width 95%
.upload-list
  margin-top 16px
  overflow hidden
  .upload-item
    float left
    margin 0 10px 20px 0
    display flex
    .detail
      width 144px
      margin-left 5px
      .detail-name
        width 144px
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
    img, video
      width 80px
      height 55px
</style>
<style lang="stylus" scoped>
.dlContent
  .dlIcon
    font-size 30px
  .dlTitle
    vertical-align text-bottom
    padding-left: 10px
    font-size: 16px
    color: #333
    font-weight: 500
  .dlMain
    position absolute
    top 64px
    left 64px
    color #666
    font-size 14px
</style>
